import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimaDoubleYpsiliLeft';
const args = {};

export class PetastiKentimaDoubleYpsiliLeft extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
